import script from "./ComboList.vue?vue&type=script&setup=true&lang=js"
export * from "./ComboList.vue?vue&type=script&setup=true&lang=js"

import "./ComboList.vue?vue&type=style&index=0&id=f256c704&scoped=true&lang=css"

import exportComponent from "D:\\Programs\\Vue\\frame2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f256c704"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QList from 'quasar/src/components/item/QList.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel,QList,QIcon});
